import { render, staticRenderFns } from "./addInformation.vue?vue&type=template&id=591c20dd&scoped=true"
import script from "./addInformation.vue?vue&type=script&lang=js"
export * from "./addInformation.vue?vue&type=script&lang=js"
import style0 from "./addInformation.vue?vue&type=style&index=0&id=591c20dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c20dd",
  null
  
)

export default component.exports